import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PatientMedicationsUIHelpers";

const PatientMedicationsUIContext = createContext();

export function usePatientMedicationsUIContext() {
  return useContext(PatientMedicationsUIContext);
}

export const PatientMedicationsUIConsumer =
  PatientMedicationsUIContext.Consumer;

export function PatientMedicationsUIProvider({
  PatientMedicationsUIEvents,
  children,
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openDetailPatientAppointmentPage:
      PatientMedicationsUIEvents.openDetailPatientAppointmentPage,
  };

  return (
    <PatientMedicationsUIContext.Provider value={value}>
      {children}
    </PatientMedicationsUIContext.Provider>
  );
}
